import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

const native = () => Capacitor.isNativePlatform();

export const authStorage = {
  getItem: async (name) => {
    if (!native()) return localStorage.getItem(name);
    const persisted = (await Preferences.get({ key: name })).value;
    if (persisted) return persisted;
    // Preserve the session of users upgrading from versions that kept the
    // Zustand payload only in the WebView's localStorage.
    const legacy = localStorage.getItem(name);
    if (legacy) await Preferences.set({ key: name, value: legacy });
    return legacy;
  },
  setItem: async (name, value) => native() ? Preferences.set({ key: name, value }) : localStorage.setItem(name, value),
  removeItem: async (name) => native() ? Preferences.remove({ key: name }) : localStorage.removeItem(name),
};

export function mirrorSessionTokens(state) {
  if (state?.accessToken) localStorage.setItem('accessToken', state.accessToken);
  else localStorage.removeItem('accessToken');
  if (state?.refreshToken) localStorage.setItem('refreshToken', state.refreshToken);
  else localStorage.removeItem('refreshToken');
}
